var s = s || {};
s.Utils = s.Utils || {};
s.Utils.focusFirstDescendant = function(t) {
  for (var e = 0; e < t.childNodes.length; e++) {
    var r = t.childNodes[e];
    if (s.Utils.attemptFocus(r) || s.Utils.focusFirstDescendant(r))
      return !0;
  }
  return !1;
};
s.Utils.focusLastDescendant = function(t) {
  for (var e = t.childNodes.length - 1; e >= 0; e--) {
    var r = t.childNodes[e];
    if (s.Utils.attemptFocus(r) || s.Utils.focusLastDescendant(r))
      return !0;
  }
  return !1;
};
s.Utils.attemptFocus = function(t) {
  if (!s.Utils.isFocusable(t))
    return !1;
  s.Utils.IgnoreUtilFocusChanges = !0;
  try {
    t.focus();
  } catch (e) {
  }
  return s.Utils.IgnoreUtilFocusChanges = !1, document.activeElement === t;
};
s.Utils.isFocusable = function(t) {
  if (t.tabIndex > 0 || t.tabIndex === 0 && t.getAttribute("tabIndex") !== null)
    return !0;
  if (t.disabled)
    return !1;
  switch (t.nodeName) {
    case "A":
      return !!t.href && t.rel !== "ignore";
    case "INPUT":
      return t.type !== "hidden" && t.type !== "file";
    case "BUTTON":
    case "SELECT":
    case "TEXTAREA":
      return !0;
    default:
      return !1;
  }
};
s.Utils.triggerEvent = function(t, e, ...r) {
  let i;
  /^mouse|click/.test(e) ? i = "MouseEvents" : /^key/.test(e) ? i = "KeyboardEvent" : i = "HTMLEvents";
  const n = document.createEvent(i);
  return n.initEvent(e, ...r), t.dispatchEvent ? t.dispatchEvent(n) : t.fireEvent("on" + e, n), t;
};
s.Utils.keys = {
  tab: 9,
  enter: 13,
  space: 32,
  left: 37,
  up: 38,
  right: 39,
  down: 40,
  esc: 27
};
const a = s.Utils;
export {
  a as default
};
